




































































import AbpBase from "../../../lib/abpbase";
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import {GetCityList, InsertCity, UpdateCityById, DeleteCity, GetProvinceList} from '../../../api/basicDictionary'
import {GetPinYin, GetWuBi} from '../../../api/sys'
@Component
export default class Country extends AbpBase {
	key = '' //查询条件
	page = 1 //当前页
	dialogTitle = ''
	dialogForm: any = {}
	dialogFormVisible = false
	dialogFormLabelWidth = '100px'
	tableTotalSize = 0
	tableData = []
	provs = []
	tableLoading = false
	created() {
		this.getData()
		this.getProvs()
	}
	visibleChange(value: boolean) {
		if (!value) {
			this.$emit('input', value);
			(this.$refs.form as any).resetFields()
		}
	}
	columns = [
		{
			key: 'provName',
			title: '所属省'
		},
		{
			key: 'cityName',
			title: '市名称'
		},
		{
			key: 'cityPY',
			title: '拼音助记符'
		},
		{
			key: 'cityWB',
			title: '五笔助记符'
		},
		{
			key: 'status',
			title: '是否启用',
			render:(h:any, p:any)=>{
				return h('span', p.row.status ? '启用' : '禁用')
			}
		},
		{
			key: 'spare',
			title: '备注'
		},
		{
			key: '',
			width: 190,
			title: '操作',
			render:(h:any, p:any)=>{
				return h('div', [
					h('Button',{
						props:{type: 'primary'},
						style:{marginRight:'20px'},
						on:{
							click:()=>{
								this.edit(p.row)
							}
						}
					},'编辑'),
					h('Button',{
						props:{type: 'error'},
						on:{
							click:()=>{
								this.del(p.row)
							}
						}
					},'删除'),
				])
			}
		},
	]
	async getCode(val: any){
		let query = {inputStr: val}
		let res1 = await GetPinYin(query)
		let res2 = await GetWuBi(query)
		this.dialogForm.cityPY = res1
		this.dialogForm.cityWB = res2
	}
	//获取所有省做下拉
	private async getProvs(){
		let res = await GetProvinceList({
			SkipCount: 1,
			MaxResultCount: 10000
		})
		this.provs = res.items
	}
	createCounty() {
		this.dialogTitle = '新增市'
		this.dialogForm = {status:true,cityPY:'',cityWB:''}
		this.dialogFormVisible = true
	}
	private async getData() {
		this.tableLoading = true
		let res = await GetCityList({
			QueryString: this.key,
			SkipCount: this.page,
			MaxResultCount: 10
		})
		this.tableData = res.items
		this.tableTotalSize = res.totalCount
		this.tableLoading = false
	}

	handleClose() {
		this.dialogFormVisible = false
	}

	edit(row: any) {
		this.dialogTitle = '编辑市'
		this.dialogForm = JSON.parse(JSON.stringify(row))
		this.dialogFormVisible = true
	}
	async del(row: any){
		this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
			let res = await DeleteCity({Id: row.id})
			this.getData()
		}).catch(() => {

		});

	}
	async confirm(){
		(this.$refs.form as any).validate(async (valid:boolean)=>{
			if(valid){
				this.provs.forEach((item: any) => {
					if (item.id === this.dialogForm.provId)	{
						this.dialogForm.provName = item.provName
					}
				})
				if (this.dialogTitle === '新增市') {
					let res = await InsertCity(this.dialogForm)
				} else if (this.dialogTitle === '编辑市') {
					let res = await UpdateCityById(this.dialogForm)
				}
				this.dialogFormVisible = false
				this.getData()
			}
		})

	}
	rules = {
		provId:[{required: true, message: '请输入内容', trigger: 'blur'}],
		cityName:[{required: true, message: '请输入内容', trigger: 'blur'}],
		cityPY:[{required: true, message: '请输入内容', trigger: 'blur'}],
		cityWB:[{required: true, message: '请输入内容', trigger: 'blur'}],
	}
	pageChange(val: any){
		this.page = val
		this.getData()
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/basicDictionary/city/index.vue